import { FetchRequestAdapter } from "@microsoft/kiota-http-fetchlibrary";
import { createAdminClient } from "../generated/adminClient.js";
/**
 * Authentication provider for Keycloak Admin Client that adds Bearer token to requests.
 */
class KeycloakAuthProvider {
    #getAccessToken;
    constructor(getAccessToken) {
        this.#getAccessToken = getAccessToken;
    }
    async authenticateRequest(request) {
        const token = await this.#getAccessToken();
        if (token) {
            request.headers.add("Authorization", `Bearer ${token}`);
        }
    }
}
/**
 * Creates a clients v2 endpoint configured with the KeycloakAdminClient's
 * base URL, access token, and realm.
 */
function createClientsV2Endpoint(client) {
    const authProvider = new KeycloakAuthProvider(() => client.getAccessToken());
    const adapter = new FetchRequestAdapter(authProvider);
    adapter.baseUrl = client.baseUrl;
    const adminClient = createAdminClient(adapter);
    return adminClient.admin.api.byRealmName(client.realmName).clients.v2;
}
/**
 * Clients v2 API resource.
 * Provides access to the new versioned clients API using the configured realm.
 */
export class ClientsV2 {
    #client;
    constructor(client) {
        this.#client = client;
    }
    /**
     * Get the clients v2 endpoint for the currently configured realm.
     * Returns a fluent API builder for client operations.
     *
     * @returns The clients v2 endpoint
     */
    api() {
        return createClientsV2Endpoint(this.#client);
    }
}
//# sourceMappingURL=clientsV2.js.map